module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/4_a7c68462134b86aa681840f29c19b043.png";